import { bindCardSwipeButton } from '../shared/card-swipe-button.js';
import { getPledgePayConfig } from './pledge-pay-config';
import { submitPledgeSwipePayment } from './pledge-pay-bill-submit';
import { showPledgeBillPayErrors } from './pledge-pay-validate';

const SWIPE_BUTTON_MISSING_MESSAGE = 'The swipe button is missing from this page, please refresh the page to swipe a card.';

function singleGatewayId(pledges) {
    const gatewayIds = new Set(
        (pledges || [])
            .map((pledge) => parseInt(pledge.gateway_id, 10))
            .filter((gatewayId) => Number.isFinite(gatewayId) && gatewayId > 0)
    );
    return gatewayIds.size === 1 ? [...gatewayIds][0] : null;
}

function initPledgeSwipePay($payRoot, pledges, cfg = null) {
    const wrap = $payRoot.find('[data-card-swipe]').get(0);
    if (!wrap || wrap.dataset.swipeInitialized === 'true') {
        return;
    }

    const config = cfg || getPledgePayConfig();
    if (!config.swipeEnabled) {
        return;
    }

    const gatewayId = singleGatewayId(pledges);
    if (!gatewayId) {
        return;
    }

    const gatewayJavascriptUrl = config.gatewayJavascriptUrlsById?.[String(gatewayId)];
    const gatewayApi = config.managerPledgeBillGatewayApisById?.[String(gatewayId)];
    if (!gatewayJavascriptUrl || !gatewayApi) {
        return;
    }

    const button = wrap.querySelector('[data-card-swipe-button]');
    if (!button) {
        showPledgeBillPayErrors($payRoot, [SWIPE_BUTTON_MISSING_MESSAGE]);
        return;
    }

    wrap.dataset.swipeInitialized = 'true';

    bindCardSwipeButton({
        wrap,
        button,
        gatewayJavascriptUrl,
        gatewayApi,
        onSwipe: (result) => submitPledgeSwipePayment($payRoot, config, result, gatewayId),
        onError: (message) => showPledgeBillPayErrors($payRoot, [message]),
    });
}

export { initPledgeSwipePay };
